import React, { useState, useMemo, useEffect } from "react";
import { useCMTag } from "api/api";
import moment from "moment";
import { LineChart, Line, XAxis, YAxis, ResponsiveContainer } from "recharts";
import { stdTimeOptions, limitedYarTimeOption } from "utility/timeOptions";
import { Electricity_ConsumedProduced, TimeOption } from "model/Datatypes";
import TouchCard from "./TouchCard";

interface IElectricity {
  tags: Electricity_ConsumedProduced["tags"];
}

const Electricity: React.FC<IElectricity> = ({ tags }) => {
  const [time, setTime] = useState<TimeOption>(limitedYarTimeOption);
  // const [avgCop, setAvgCop] = useState<null | number>(null);

  const electricityTags = useMemo(() => {
    return tags.power;
  }, [tags]);

  const [graphData, setgraphData] = useState<object[]>([]);

  const { cmData: electricityData, loading } = useCMTag(
    electricityTags,
    time.from,
    time.to,
    time.groupingsType,
    true
  );

  useEffect(() => {
    if (electricityData) {
      const formattedElectricityData = electricityData.points.map((p) => ({
        time: p.time,
        electricityUsed: p.value,
      }));
      setgraphData(formattedElectricityData);
    }
  }, [electricityData]);

  //   useEffect(() => {
  //     if (copData) {
  //       // setAvgCop(getAverage(copData.points.map((p) => p.value).filter((v) => v < 10 && v > 0)));
  //       //prepare to graph...
  //       const cleaned = copData.points
  //         .filter((p) => p.value > 0 && p.value < 10)
  //         .map((p) => ({ time: p.time, cop: p.value }));
  //       setgraphData(cleaned);
  //     }
  //   }, [copData]);
  return (
    <>
      <div className="w-full h-full bg-white">
        <TouchCard
          timeOptions={[...stdTimeOptions, limitedYarTimeOption]}
          timeSelected={time}
          onNewTimeSelected={(newTime) => setTime(newTime)}
          size="full"
          loading={loading}
          flipdropdown={true}
          graphTitle="Electricity used"
        >
          <div style={{ width: "105%", marginLeft: "-5%" }} className="px-4 mt-2">
            <ElectricityHistoricGraph graphData={graphData} />
          </div>
        </TouchCard>
      </div>
    </>
  );
};

export default Electricity;

const ElectricityHistoricGraph: React.FC<{ graphData?: object[] }> = ({ graphData }) => {
  const momentFromat = "MMMM YYYY";
  return (
    <ResponsiveContainer height={340}>
      <LineChart data={graphData}>
        <XAxis dataKey="time" tickFormatter={(val) => moment(val).format(momentFromat)} />
        <YAxis />
        <Line
          type="monotone"
          dataKey="electricityUsed"
          stroke="#2FD2A6"
          strokeWidth={3}
          dot={false}
        />
      </LineChart>
    </ResponsiveContainer>
  );
};
